// Rätsel-Wertung des Spielers, Elo-artig wie bei lichess: Erwartung aus dem Abstand zur Rätsel-Wertung,
// am Anfang große Schritte, damit sich die Wertung schnell einpendelt. Gespeichert im Browser, bis es Konten gibt.
import { loadPref, savePref } from './prefs';

export interface PuzzleResult {
  id: string;
  rating: number;
  win: boolean;
  delta: number;
}

export interface PuzzleRating {
  rating: number;
  games: number;
  /** zuletzt gezogene Rätsel, damit sie nicht gleich wiederkommen */
  seen: string[];
  /** neueste zuerst */
  history: PuzzleResult[];
}

const SEEN = 500;
const HISTORY = 12;

export function ratingChange(mine: number, puzzle: number, win: boolean, games: number): number {
  const k = games < 10 ? 60 : games < 30 ? 32 : 16;
  const expected = 1 / (1 + 10 ** ((puzzle - mine) / 400));
  return Math.round(k * ((win ? 1 : 0) - expected));
}

export function loadRating(): PuzzleRating {
  const r = loadPref<Partial<PuzzleRating>>('puzzle', {});
  return {
    rating: Number.isFinite(r.rating) ? Math.max(400, Math.min(3000, r.rating!)) : 1500,
    games: Number.isFinite(r.games) ? r.games! : 0,
    seen: Array.isArray(r.seen) ? r.seen.slice(-SEEN) : [],
    history: Array.isArray(r.history) ? r.history.slice(0, HISTORY) : [],
  };
}

export function markSeen(r: PuzzleRating, id: string): PuzzleRating {
  const next = { ...r, seen: [...r.seen.filter(s => s !== id), id].slice(-SEEN) };
  savePref('puzzle', next);
  return next;
}

/** Ergebnis eintragen; `counts` = false (Hinweis genutzt): Wertung bleibt, Ergebnis steht trotzdem in der Liste */
export function record(r: PuzzleRating, id: string, puzzle: number, win: boolean, counts: boolean): PuzzleRating {
  const delta = counts ? ratingChange(r.rating, puzzle, win, r.games) : 0;
  const next = {
    ...r,
    rating: Math.max(400, Math.min(3000, r.rating + delta)),
    games: r.games + (counts ? 1 : 0),
    history: [{ id, rating: puzzle, win, delta }, ...r.history].slice(0, HISTORY),
  };
  savePref('puzzle', next);
  return next;
}
